// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-to-plan[data-v-4e6d754a]{padding-left:.75em;padding-right:.75em}.no-action[data-v-4e6d754a]{display:inline-block;text-align:center}", ""]);
// Exports
module.exports = exports;
